// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"10e62ac6","310":"5a9c048c","854":"6e5f98a9"}[chunkId] + ".chunk.css";
};